var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCpf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 1H2.8C1.80589 1 1 1.81548 1 2.82143V16.1786C1 17.1845 1.80589 18 2.8 18H11.2C12.1941 18 13 17.1845 13 16.1786V2.82143C13 1.81548 12.1941 1 11.2 1Z",
    stroke: "#6A6A6A",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20068 2.82129H8.80068",
    stroke: "#6A6A6A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90558 10.5818C9.76406 10.4292 9.59265 10.3082 9.4023 10.2265C9.21195 10.1447 9.00684 10.1041 8.80008 10.1071C8.36508 10.1071 7.97171 10.2744 7.69233 10.5788C7.41296 10.8831 7.27233 11.3043 7.30458 11.7551C7.36871 12.6461 8.03958 13.3705 8.80008 13.3705C9.56058 13.3705 10.2303 12.6461 10.2952 11.7559C10.3282 11.3089 10.1895 10.8918 9.90558 10.5818ZM11.3385 16.7857H6.26171C6.19562 16.7867 6.1301 16.7731 6.06978 16.7458C6.00946 16.7184 5.9558 16.678 5.91258 16.6274C5.86573 16.5706 5.83209 16.5039 5.81418 16.4322C5.79626 16.3604 5.79452 16.2856 5.80908 16.213C5.93096 15.5467 6.31083 14.987 6.90783 14.5943C7.43808 14.2455 8.11008 14.0535 8.80008 14.0535C9.49008 14.0535 10.1621 14.2455 10.6923 14.5943C11.2893 14.987 11.6692 15.5467 11.7911 16.213C11.8056 16.2856 11.8039 16.3604 11.786 16.4322C11.7681 16.5039 11.7344 16.5706 11.6876 16.6274C11.6444 16.678 11.5907 16.7184 11.5304 16.7458C11.4701 16.7731 11.4045 16.7867 11.3385 16.7857Z",
    fill: "#6A6A6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCpf);
export default __webpack_public_path__ + "static/media/icon-cpf.43da9e5e9ff232536b8e5404c338a5c6.svg";
export { ForwardRef as ReactComponent };